import type { DataSchema, FormItemType, Schema } from '../../types';
import type { AnySchema } from 'yup';
import { mixed, object } from 'yup';
import { getRecordItemValidation } from './recordItemsValidation.ts';
import { capitalize } from 'lodash';

const DEFAULT_SKIP_VALIDATION_CELLS = ['FileUpload', 'Records', 'Comment', 'Button'] satisfies FormItemType[];

export const tableCellValidation = <T extends keyof P, P extends DataSchema>(
  dataSchema: P,
  rows: Schema<T, P>[],
  skipCells: FormItemType[] = DEFAULT_SKIP_VALIDATION_CELLS
) => {
  const validationShape: Record<string, AnySchema> = {};

  rows.forEach((row) => {
    const rowId = row.identifier;
    const rowValidation: Record<string, AnySchema> = {};

    if (rowId == null) return;

    Object.keys(dataSchema).forEach((key) => {
      const cellSchema = dataSchema[key];

      if (!('formItemDefinition' in cellSchema) && 'type' in cellSchema && cellSchema.type !== 'id') {
        cellSchema.formItemDefinition = {
          type: capitalize(cellSchema.type) as FormItemType,
        };
      }

      if (cellSchema.formItemDefinition) {
        const isNewRow = rowId.startsWith('new');
        const shouldSkipValidation = skipCells.includes(cellSchema.formItemDefinition.type);
        const shouldValidate = isNewRow || cellSchema.isEditable;

        if (shouldSkipValidation || !shouldValidate) {
          rowValidation[key] = mixed();
        } else {
          const validation = getRecordItemValidation(cellSchema.formItemDefinition);
          if (validation) {
            rowValidation[key] = validation;
          }
        }
      }
    });

    validationShape[rowId] = object().shape(rowValidation);
  });

  return object().shape(validationShape);
};
